import React from "react";

const SelectDropdown = props => {
    let inputClassName = props.inputClassName ? "cdx-input " + props.inputClassName : "cdx-input";
    let className = props.className ? "cdx-form-group " + props.className : "cdx-form-group";

    return (<>
        <div className={className}>
            {props.label && <label className="cdx-inpput-label">{props.label}</label>}
            <div className="cdx-input">
                <select {...props} className={inputClassName}>
                    {props.placeholder && <option value="" disabled >{props.placeholder}</option>}
                    {props.options && props.options.map(item => {
                        return <option value={item.value} key={"option-" + item.value}>{item.label} {item.teamName ? '('+item.teamName+')':''}</option>;
                    })}
                </select>

            </div>
        </div>
    </>);
};
export default SelectDropdown;